var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_IND/phone_number/index.js
 ** module id = 434
 ** module chunks = 0
 **/